import { render, staticRenderFns } from "./SettingsInvoice.vue?vue&type=template&id=5a9f8056&"
import script from "./SettingsInvoice.vue?vue&type=script&lang=js&"
export * from "./SettingsInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingsInvoice.vue"
export default component.exports